import classnames from 'classnames';
import React, { FunctionComponent } from 'react';

import { TextSize, TextWeight, Text } from '@/shared/components/Text';
import arrowBottom from '@/shared/assets/arrowBottom.svg';

import styles from './ArrowBottom.module.css';

interface ArrowBottomProps {
    onScrollTo: () => void;
    withAnimation?: boolean;
    title: string;
}

export const ArrowBottom: FunctionComponent<ArrowBottomProps> = ({
    onScrollTo,
    title,
    withAnimation = true,
}) => (
    <div
        className={styles.root}
        onClick={onScrollTo}
        onKeyPress={() => undefined}
        role="button"
        tabIndex={-1}
    >
        <Text
            className={styles.text}
            size={TextSize.CaptionElevated}
            weight={TextWeight.Regular}
            viewVariant="centered"
        >
            {title}
        </Text>
        <div className={classnames(styles.iconWrapper, { [styles.animation]: withAnimation })}>
            <img src={arrowBottom} alt="arrow" className={styles.icon} />
        </div>
    </div>
);
